// The books are kept in UAE dirhams. One constant so a second currency, if it
// ever arrives, has a single place to start from.
export const CURRENCY = "AED";

// Money always reads the same way, AED 1,234.50, regardless of the visitor's
// locale — the same reasoning as the date helper, since a browser set to a
// European locale would otherwise render that as 1.234,50.
export function formatMoney(value, { currency = CURRENCY } = {}) {
  const amount = Number(value);
  if (value === null || value === undefined || value === "" || !Number.isFinite(amount)) {
    return "—";
  }

  const [whole, fraction] = Math.abs(amount).toFixed(2).split(".");
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // Sign ahead of the currency, so in a right-aligned column the minus is the
  // first thing read rather than being buried between AED and the digits.
  const sign = amount < 0 ? "-" : "";

  return currency ? `${sign}${currency} ${grouped}.${fraction}` : `${sign}${grouped}.${fraction}`;
}

// A plain count, grouped the same way so a quantity column reads like the money
// ones: 10,047 rather than 10047.
export function formatCount(value) {
  const amount = Number(value);
  if (value === null || value === undefined || value === "" || !Number.isFinite(amount)) {
    return "—";
  }

  return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
